import { render, staticRenderFns } from "./CryptopayDm.vue?vue&type=template&id=3753fb50&scoped=true&"
import script from "./CryptopayDm.vue?vue&type=script&lang=js&"
export * from "./CryptopayDm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3753fb50",
  null
  
)

export default component.exports